import {Observable} from 'rxjs';
import i18next from 'i18next';

import {combineEpics} from 'web-app/util/redux-observable';
import * as GlobalEvent from 'web-app/services/global-event';

import * as Api from './api';
import * as Actions from './actions';

const fetchDiscountPresetsEpic = action$ =>
    action$
        .ofType(Actions.fetchAllPresets.type)
        .mergeMap(({payload}) =>
            Api.fetchPresets(payload.institutionId).map(result =>
                Actions.fetchAllPresetsSuccess.action(result.presets, result.behaviors),
            ),
        );

const updatePresetsEpic = action$ =>
    action$.ofType(Actions.updatePresets.type).mergeMap(({payload}) =>
        Api.updatePresets(payload.institutionId, payload.presets)
            .map(presets => {
                GlobalEvent.updateSuccess(i18next.t('plans.settings.discounts.presets.updateSuccessful'));
                return Actions.updatePresetsSuccess.action(presets);
            })
            .catch(error => Observable.of(Actions.updatePresetsFailed.action(error))),
    );

export default combineEpics(fetchDiscountPresetsEpic, updatePresetsEpic);
